import { ReactNode } from 'react';
import {
    CircleArrowUp, CircleDollarSign, ClockAlert, Radio, RefreshCcwDot,
} from 'lucide-react';

export type HealthMetricCardConfig =
    | {
        kind: 'single';
        id: string;
        title: string;
        groupKey: string;
        metricKey: string;
        valueLabel?: string;
        icon: ReactNode;
    }
    | {
        kind: 'salesRatio';
        id: string;
        title: string;
        groupKey: string;
        icon: ReactNode;
        valueLabel?: string;
    };

export const healthMetricCards: HealthMetricCardConfig[] = [
    {
        kind: 'single',
        id: 'growth',
        title: 'Growth',
        groupKey: 'pipeline_growth_score',
        metricKey: 'new_opportunities',
        valueLabel: 'New leads',
        icon: <CircleArrowUp />,
    },
    {
        kind: 'salesRatio',
        id: 'sales',
        title: 'Sales',
        groupKey: 'sales_performance_score',
        icon: <CircleDollarSign />,
    },
    {
        kind: 'single',
        id: 'returning_customers',
        title: 'Returning Customers',
        groupKey: 'returning_customers_score',
        metricKey: 'customers_returning_contacts',
        valueLabel: 'Customer(s)',
        icon: <RefreshCcwDot />,
    },
    {
        kind: 'single',
        id: 'channels',
        title: 'Channels',
        groupKey: 'channel_performance_score',
        metricKey: 'channel_performance_score',
        icon: <Radio />,
    },
    {
        kind: 'single',
        id: 'stuck_opportunities',
        title: 'Stuck Opportunities',
        groupKey: 'stuck_opportunities_score',
        metricKey: 'total_revenue_at_risk',
        valueLabel: 'Revenue at risk',
        icon: <ClockAlert />,
    },
];
